/**
 * Constantes do gerenciamento de questionários.
 *
 * Objetivo:
 * - Centralizar strings e mapeamentos UI para manter componentes pequenos e coesos.
 * - Evitar duplicação (ex.: labels de usageType e mensagens vazias do preview).
 */

export const USAGE_TYPE_TO_UI_LABEL: Record<
  "triage" | "preConsultation" | "postConsultation" | "attendance",
  string
> = {
  triage: "Triagem",
  preConsultation: "Pré-consulta",
  postConsultation: "Pós-consulta",
  attendance: "Acompanhamento",
};

export const PREVIEW_EMPTY_MESSAGE =
  "As perguntas aparecerão aqui conforme você for adicionando no construtor.";

export const EMPTY_OPTIONS_MESSAGE = "Defina as opções na área de edição da pergunta.";

export const QUESTIONNAIRE_STATUS_TO_UI: Record<
  "active" | "draft" | "unknown",
  {
    label: string;
    chipColor: "success" | "default" | "primary";
    chipVariant: "filled" | "outlined";
  }
> = {
  active: {
    label: "Ativo",
    chipColor: "success",
    chipVariant: "filled",
  },
  draft: {
    label: "Rascunho",
    chipColor: "default",
    chipVariant: "outlined",
  },
  unknown: {
    label: "Em edição",
    chipColor: "primary",
    chipVariant: "filled",
  },
};

/** Texto explicativo: recurso `unknown` não substitui a versão vista por pacientes até publicar. */
export const QUESTIONNAIRE_UNKNOWN_STATUS_TOOLTIP =
  "Este questionário está em edição no momento. Os pacientes receberão automaticamente a última versão publicada.\nSe você quiser enviar a versão mais recente, peça ao responsável pelos questionários para publicá-la.";

